import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer-landing-page',
  templateUrl: './footer-landing-page.component.html'
})
export class FooterLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  downloadAgreement() {
    const fileLink = document.createElement('a');
    fileLink.href = `${environment.aadConfig.redirect_url}/assets/static/service-agreement.pdf`;
    fileLink.download = 'service-agreement';
    document.body.appendChild(fileLink);
    fileLink.click();
  }

}
